/* global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import InputBox from '../inputs/InputBox';
import InputField from '../form/InputField';
import { ModalActions } from '../../actions/modal';
import { UserActions } from '../../actions/user';
import { OrganizationActions } from '../../actions/organization';
import { AccountActions } from '../../actions/account';
import { validateAndDispatch } from '../../helpers/form';
import { PROJROLE_ADMIN, PROJROLE_MEMBER, PROJROLE_READER } from '../../shared/constants';

const currentProjectIdSelector = (state) => {
  const projectId = state.projects.get('currentProjectId');
  return projectId || null;
};

const modalSelector = (state) => state.modal.get('modals').last();

const addProjectUserFormSelector = (state) => {
  const selector = formValueSelector('addProjectUser');
  return selector(state, 'email', 'role');
};

const AddProjectUserModalSelector = createSelector(
  [currentProjectIdSelector, addProjectUserFormSelector, modalSelector],
  (currentProjectId, addProjectUserForm, modal) => ({
    currentProjectId,
    fields: addProjectUserForm,
    modal,
  })
);

@connect(AddProjectUserModalSelector)
@reduxForm({
  form: 'addProjectUser',
  destroyOnUnmount: true,
  initialValues: {
    email: '',
  },
})
export default class AddProjectUserModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    modal: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    currentProjectId: PropTypes.string,
  };

  submit = (inValues, dispatch) => {
    const {
      reset,
      currentProjectId,
      modal,
    } = this.props;

    // console.log('currentProjectId: ', typeof currentProjectId, currentProjectId);

    const addUserType = modal.getIn(['options', 'userType']);
    let addUserAction;
    let entityId;

    const values = {};
    values.email = inValues.email;

    const validation = {};
    validation.email = [{ rule: 'email', label: 'User email' },
                        { rule: 'required', label: 'User email' }];

    switch (addUserType) {
      case 'organization':
        entityId = modal.getIn(['options', 'params', 'organizationId']);
        values.role = '2';
        addUserAction = OrganizationActions.addUser(entityId, values);
        break;
      case 'account':
        entityId = modal.getIn(['options', 'params', 'accountId']);
        values.role = '2';
        addUserAction = AccountActions.addUser(entityId, values);
        break;
      default:
        entityId = currentProjectId;
        values.role = inValues.role;
        validation.role = [{ rule: 'required', label: 'User role' }, (val) => {
          if (['2', '3', '4'].indexOf(val) === -1) throw new Error('Please specify a valid role.');
        }];
        addUserAction = UserActions.addProjectUser(entityId, values);
        break;
    }

    return validateAndDispatch(
      dispatch,
      addUserAction,
      validation,
      values
    ).then(() => {
      reset();
      dispatch(ModalActions.hideModal({ name: 'AddProjectUserModal' }));
    });
  }

  roleOptions = () => [
    { label: 'Choose a role...', value: '' },
    { label: 'Admin', value: PROJROLE_ADMIN },
    { label: 'Member', value: PROJROLE_MEMBER },
    { label: 'Reader', value: PROJROLE_READER },
  ];

  render() {
    const {
      // fields: { email, role },
      handleSubmit,
      submitting,
      // reset,
      modal,
    } = this.props;

    const addUserType = modal.getIn(['options', 'userType']);
    let title;

    switch (addUserType) {
      case 'organization':
        title = 'Add Organization User';
        break;
      case 'account':
        title = 'Add Account User';
        break;
      default:
        title = 'Add Project User';
        break;
    }

    // console.log('title', title, this.submit);
    // console.log('handle', handleSubmit);

    return (<div className="fs-modal-content">
      <h1>{title}</h1>
      <div>
        <form onSubmit={handleSubmit(this.submit)}>
          <div className="modal-form-wrapper">
            <Field
              component={InputBox}
              name="email"
              type="text"
              className="form-control"
              parse={value => value.toLowerCase()}
              label={'Email'}
              placeholder={'Enter email address'}
              small={'Enter user\'s email address.'}
            />
            {(addUserType !== 'organization') && (addUserType !== 'account') &&
              <Field
                name="role"
                type="select"
                component={InputField}
                className="form-control user-role-select"
                options={this.roleOptions()}
                label="Select Role"
                small="Specify the user's role."
              />
            }
          </div>
          <div className="modal-form-button-wrapper">
            <button
              type="submit"
              className="btn btn-primary modal-submit-btn"
              onClick={handleSubmit(this.submit)}
              disabled={submitting}
              data-test="addUserButton"
            >
              {title}
            </button>
          </div>
        </form>
      </div>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/AddProjectUserModal.js